/** Shared enums mirrored in the Prisma schema. */
export const PAYMENT_STATUSES = [
    "PENDING",
    "PROCESSING",
    "SUCCESS",
    "FAILED",
    "ABANDONED",
    "REFUNDED",
    "PARTIALLY_REFUNDED",
];
export const ORDER_STATUSES = [
    "CREATED",
    "AWAITING_PAYMENT",
    "PAID",
    "FULFILLED",
    "CANCELLED",
    "REFUNDED",
];
export const PLATFORM_STATUSES = ["ACTIVE", "SUSPENDED", "ARCHIVED"];
export const REFUND_STATUSES = ["PENDING", "PROCESSING", "COMPLETED", "FAILED"];
export const LEDGER_ENTRY_TYPES = [
    "CHARGE",
    "FEE",
    "REFUND",
    "SETTLEMENT",
    "ADJUSTMENT",
];
export const ACTOR_TYPES = ["USER", "PLATFORM", "SYSTEM"];
/** Editorial status of a blog/update post. Only PUBLISHED reaches the site. */
export const POST_STATUSES = ["DRAFT", "PUBLISHED", "ARCHIVED"];
/** Editorial category, used for the badge and filter on the public site. */
export const POST_CATEGORIES = ["UPDATE", "RELEASE", "NEWS", "MAINTENANCE"];
export const WEBHOOK_DELIVERY_STATUSES = [
    "PENDING",
    "DELIVERED",
    "FAILED",
    "EXHAUSTED",
];
export const JOB_STATUSES = ["QUEUED", "RUNNING", "COMPLETED", "FAILED", "DEAD"];
export const JOB_TYPES = [
    "VERIFY_PAYMENT",
    "PLATFORM_CALLBACK",
    "SEND_NOTIFICATION",
    "RECONCILIATION",
];
export const PERMISSIONS = [
    "platform:read",
    "platform:write",
    "transaction:read",
    "transaction:refund",
    "report:read",
    "user:manage",
    "role:manage",
    "audit:read",
    "settings:manage",
    "reconciliation:run",
    "content:manage",
];
export const ROLE_SLUGS = ["OWNER", "ADMIN", "FINANCE", "SUPPORT", "VIEWER"];
/** Allowed payment state transitions. Enforced server-side. */
export const PAYMENT_TRANSITIONS = {
    PENDING: ["PROCESSING", "SUCCESS", "FAILED", "ABANDONED"],
    PROCESSING: ["SUCCESS", "FAILED", "ABANDONED"],
    SUCCESS: ["REFUNDED", "PARTIALLY_REFUNDED"],
    PARTIALLY_REFUNDED: ["REFUNDED"],
    FAILED: [],
    ABANDONED: [],
    REFUNDED: [],
};
export function canTransition(from, to) {
    return PAYMENT_TRANSITIONS[from]?.includes(to) ?? false;
}
/** Terminal states that must never be re-processed. */
export const TERMINAL_PAYMENT_STATUSES = [
    "SUCCESS",
    "FAILED",
    "ABANDONED",
    "REFUNDED",
];
//# sourceMappingURL=enums.js.map